
/* eslint-disable import/no-cycle */
import {
  defineComponent, onMounted, onUnmounted, Ref, ref, watch,
} from 'vue';
import { useSpacesStore } from '../store/spacesStore';
import { CONTACT_STATUS, NETWORK_CONTACT_TYPES } from '@/types/enums';
import SpacesSuggestions from '../components/SpacesSuggestions.vue';
import SpacesUser from '../components/SpacesUser.vue';
import MonitoringService from '@/services/MonitoringService';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    SpacesSuggestions,
    SpacesUser,
  },
  setup() {
    const mainStore = useMainStore();
    const spacesStore = useSpacesStore();

    const scroller: Ref<HTMLElement | null> = ref(null);

    let pagesAmount = 0;
    let currentPageIndex = 0;

    function searchContacts(query: string, pageIndex: number, pageSize: number, push?: boolean): void {
      spacesStore.searchContacts(query, pageIndex, pageSize, push).then((response) => {
        if (response.success) {
          pagesAmount = response.results.data.totalPages;
          currentPageIndex = response.results.data.number;
        }
      });
    }

    function onScroll() {
      const isBottom = Math.round(scroller.value!.scrollTop + scroller.value!.clientHeight) >= Math.round(scroller.value!.scrollHeight);

      if (isBottom && pagesAmount !== currentPageIndex + 1) {
        searchContacts(spacesStore.search, currentPageIndex + 1, 10, true);
      }
    }

    function resolveUserType(contactStatus: CONTACT_STATUS, accountId: string): NETWORK_CONTACT_TYPES {
      if (contactStatus === CONTACT_STATUS.REQUEST_SENT) {
        return NETWORK_CONTACT_TYPES.OUTCOMING;
      }
      if (contactStatus === CONTACT_STATUS.REQUEST_RECEIVED) {
        return NETWORK_CONTACT_TYPES.INVITATION;
      }
      if (contactStatus === CONTACT_STATUS.CONTACT) {
        return NETWORK_CONTACT_TYPES.MY;
      }
      if (accountId === mainStore.user.accountId) {
        return NETWORK_CONTACT_TYPES.ME;
      }
      return NETWORK_CONTACT_TYPES.SUGGESTION;
    }

    let timeout: ReturnType<typeof setTimeout>;
    watch(() => spacesStore.search, (newSearch, oldSearch) => {
      clearTimeout(timeout);
      if (newSearch === '') {
        spacesStore.searchContactsList = [];
      } else {
        timeout = setTimeout(() => {
          searchContacts(newSearch, 0, 10);
        }, 300);
      }
    });

    onMounted(() => {
      MonitoringService.sendPageMountedSpeed();
    });

    onUnmounted(() => {
      spacesStore.search = '';
    });

    return {
      spacesStore,
      scroller,
      resolveUserType,
      onScroll,
      NETWORK_CONTACT_TYPES,
    };
  },
});
